export enum OptionPrintQuestionTotem {
    NoAction = 'NoAction',
    Question = 'Question',
    AutoPrint = 'AutoPrint'
}
